// A comment is rendered as Markdown with no HTML, so tags show as text. A deflected AI answer is saved as a
// comment with the HTML its disclaimer and References box are built from (OpenAiParser adds it for the request
// portal, which renders HTML): `<br>` and a styled `<div>`. Those two are turned into the line and paragraph
// breaks they stand for - the same conversion the AI answer's Teams card uses - here, where the comment is drawn,
// so comments already saved are fixed too. Code blocks are left alone: HTML shown as code stays as written.

const FENCE = /^ {0,3}(`{3,}|~{3,})/;
const DIV = /<\/?div\b[^>]*>/gi;
const BR = /<br\s*\/?>/gi;

export const htmlBreaksToMarkdown = (text: string): string => {
  let inFence = false;
  return text.split('\n').map(line => {
    if (FENCE.test(line)) {
      inFence = !inFence;
      return line;
    }
    if (inFence) return line;
    return line.replace(DIV, '\n\n').replace(BR, '\n');
  }).join('\n');
};
